const baseURL = process.env.REACT_APP_DEV_URL;
const mapApiKey = process.env.REACT_APP_MAP_API_KEY || "";
const geoNamesUrl = "https://secure.geonames.org/";
export const GEOCODING_API_URL = (lat: number, lng: number) =>
  `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&accept-language=en`;
export { baseURL, geoNamesUrl, mapApiKey };
